import DiagramWithToggleKey from "../shared/DiagramWithToggleKey";
import NutritionIodineCombined from "./index";

const NutritionIodineWithToggleKey = props => (
  <DiagramWithToggleKey
    CombinedDiagram={NutritionIodineCombined}
    keyControlsId="nutrition-iodine-key"
    {...props}
  />
);

export default NutritionIodineWithToggleKey;
